import React, { useEffect } from "react";
import { connect } from "react-redux";
// import { getSupplierAction } from "../../../../modules/suppliers/Actions";
import { getSinglePendingSupplierAction, moderateCreateSinglePendingSupplier, getPendingSuppliersAction } from '../../../../modules/supplierModeration/suppliers/Actions';

import { getSupplierCategoriesAction } from '../../../../modules/supplierCategories/Actions';

import { supplierCategoryByIdSelector } from '../../../../modules/supplierCategories/Selectors';

import { updatePendingSupplierAction } from "../../../../modules/supplierModeration/suppliers/Actions";
import {
  suppliersIsLoadingSelector,
  supplierByIdSelector,
} from "../../../../modules/suppliers/Selectors";

import { pendingSupplierByIdSelector, pendingSuppliersSelector } from '../../../../modules/supplierModeration/suppliers/Selectors'

import { Formik } from "formik";

import {
  InputField,
  Upload,
  TextArea,
  Select,
  SearchableSelect,
  CheckBox,
  FormSectionTitle,
  Separator,
} from "../../../../components/form";

import SupplierBIOi18n from "../../../../components/form/i18nForm/FormBIOi18n";
import WorkingHours from "../../../../components/form/WorkingHours";
import ModerationForm from "../../../../components/form/ModerationForm";
import { pendingSuppliersIsLoadingSelector } from "../../../../modules/supplierModeration/suppliers/Selectors";
import { get } from "object-path";
import getLangData from "../../../../utils/getLangData";
// import suppliers from ".";
// import { values } from "lodash";
import axiosInstance from '../../../../helpers/api';
import { errorNotificationFromError } from '../../../../modules/notifications/Actions';

const companySizeOptions = [
  {
    label: "1-10",
    value: "1-10",
  },
  {
    label: "10-100",
    value: "10-100",
  },
  {
    label: "100-1000",
    value: "100-1000",
  },
  {
    label: "More Than 1000",
    value: "1000+",
  },
];

const options = [
  {
    "value": "0",
    "label": "Manufacturer"
  },
  {
    "value": "1",
    "label": "Distributor"
  }
];

const ViewPendingSupplier = (props) => {
  // suppliers
  const {
    getSupplier,
    supplier,
    supplierId,
    moderationId,
    suppliersIsLoading,
    updateSupplier,
    pendingSuppliersIsLoading,
    getSinglePendingSupplier,
    getCategories,
    supplierCategory,
    moderateSupplier,
    getSuppliers
  } = props;

  useEffect(() => {
    getCategories({ size: 50 });
    // getSinglePendingSupplier(supplierId);
    getSuppliers()
    getPendingSuppliersAction()
    console.log(supplier)
  }, [getSinglePendingSupplier, supplierId]);

  const lang = getLangData().fields
  return (

    <Formik
      enableReinitialize
      onSubmit={(values) => {
        moderateSupplier({
          id: supplierId,
        }, values.moderationType);
      }}
      initialValues={{ ...supplier }}
    >
      {({ values, handleSubmit }) => (
        <>
          <ModerationForm
            isDisabled={false}
            isLoading={suppliersIsLoading || pendingSuppliersIsLoading}
            handleSubmit={handleSubmit}
            heading={supplier ? `${lang.view} [${supplier.businessName}]` : null}
          >
            <FormSectionTitle>{lang.basic_information} :</FormSectionTitle>
            {/* <SearchableSelect
            name='userID'
            label='User'
            optionLabel={(option) => `${option.firstName} ${option.lastName}`}
          /> */}
            <SearchableSelect
              isMulti
              name='categoryData'
              label={lang.supplier_category}
            />
            <InputField name='businessName' label={lang.business_name} />
            <Select
              inArray={true}
              options={options}
              name='businessType'
              label={lang.business_type}
            />
            <Upload
              data={{ customerID: "usads9123213k219d123" }}
              name='logo'
              label={getLangData().fields.logo}
              S3Bucket='warshatna-users'
              API='customer/customer-category-image-signedurl/'
            />
            <TextArea name='supplierBIO' label={lang.supplier_bio} />
            <SupplierBIOi18n name='supplierBIOi18n' />

            <Separator />
            <FormSectionTitle>{lang.company_and_store}</FormSectionTitle>
            <CheckBox
              name='onlineStore'
              label={lang.online_store}
              subLabel='I have Online Store.'
            />
            <CheckBox
              name='offlineStore'
              label={lang.offline_store}
              subLabel='I have Offline Store.'
            />
            <InputField name='yearEstablished' label={lang.year_established} />
            <CheckBox
              name='regCompany'
              label={lang.registered_company}
              subLabel='I have Registered Company.'
            />
            <Select
              options={companySizeOptions}
              name='companySize'
              label={lang.company_size}
            />

            <Separator />
            <FormSectionTitle>{lang.contact_person_details}</FormSectionTitle>
            <InputField name='contactPerson' label={lang.contact_person} />
            <InputField name='contactPersonTitle' label={lang.contact_person_title} />
            <InputField name='contactPersonPhone' label={lang.contact_person_phone} />
            <InputField name='contactPersonEmail' label={lang.contact_person_email} />
            <Separator />
            <FormSectionTitle> {lang.company_and_store} </FormSectionTitle>
            <InputField name='website' label={lang.website} />
            <InputField name='facebook' label={lang.facebook} />
            <InputField name='instagram' label={lang.instagram} />
            <InputField name='youtube' label={lang.youtube} />
            <Separator />
            <FormSectionTitle>{lang.working_hours} :</FormSectionTitle>
            <WorkingHours name='workingHours' />
            <Separator />
          </ModerationForm>
          <button className="btn btn-secondary mb-3" onClick={async () => {
            try {
              let data = values;
              delete data.geolocation;
              await axiosInstance.put(`/supplier/${data.supplierID}`, data);
              await axiosInstance.delete(`/supplier-staging/${supplier._id}`);
              window.location.href = '/suppliers-moderation/suppliers'
            } catch (error) {
              errorNotificationFromError(error)
            }
          }} >{lang.edit_approve}</button>
        </>
      )
      }
    </Formik >
  );
};

const mapStateToProps = (state, props) => {
  const supplierId = props.match.params.supplierId;
  const moderationId = props.match.params.moderationId;
  let categoryId;
  return {
    categoryId,
    moderationId,
    supplierId,
    suppliersIsLoading: suppliersIsLoadingSelector(state),
    pendingSuppliersIsLoading: pendingSuppliersIsLoadingSelector(state),
    // supplier: supplierByIdSelector(state, supplierId),
    supplier: pendingSupplierByIdSelector(state, supplierId),
    supplierCategory: supplierCategoryByIdSelector(state, categoryId)
  };
};

const mapDispatchToProps = {
  moderateSupplier: moderateCreateSinglePendingSupplier,
  // getSupplier: getSupplierAction,
  getSinglePendingSupplier: getSinglePendingSupplierAction,
  getCategories: getSupplierCategoriesAction,
  getSuppliers: getPendingSuppliersAction

};

export default connect(mapStateToProps, mapDispatchToProps)(ViewPendingSupplier);
